import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import GeneralInfoPopup from './GeneralInfoPopup';
import { getSearchParam, removeQueryParameters } from '../util/url';
import { LocalizationContext } from './LanguageContext/LocalizationContext';

const AuthenticationIssuePopup: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const { translation } = useContext(LocalizationContext);
    const [open, setOpen] = useState<boolean>(false);

    const error: string|null = getSearchParam('error');

    useEffect(() => {
        if (error && !open) {
            setOpen(true);
        } else if (!error && open) {
            setOpen(false);
        }
    }, [error]);

    const onClose = () => {
        removeQueryParameters(history, location, [ 'error', 'state' ]);
        setOpen(false);
    };

    if (!open) return null;

    let messageText = '';

    switch (error) {
        case 'idp_authorization_failed':
            messageText = translation.authenticationInterruptedByUser;
            break;
        case 'authorization_code_expired':
            messageText = translation.authenticationTimeout;
            break;
        case 'authorization_failed':
            messageText = translation.authenticationParameterError;
            break;
        case 'general_failure':
            messageText = translation.authenticationUnknowError;
            break;
    }

    return (
        <GeneralInfoPopup
            open={open}
            onClose={onClose}
            titleText={translation.authenticationInterrupedTitle}
            messageText={messageText}
            confirmText={translation.authenticationIssueConfirm}
        />
    );
};

export default AuthenticationIssuePopup;